import React, { useState } from 'react'
import { Button, Form, Input, Radio, Upload } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

const acceptedUploadFormat = 'application/json'
function GA4extras (props) {
  const { defConfig, defPlaceholder, editMode } = props
  const { t: ln_t } = useTranslation()
  const formVal = Form.useWatch() || {}
  const [fileList, setFileList] = useState()

  // ----- upload config -----
  const handleUpload = ({ file, onSuccess }) => {
    setFileList([file])
    return onSuccess()
  }

  const uploadProps = {
    accept: acceptedUploadFormat,
    maxCount: 1,
    fileList,
    onRemove: () => setFileList([]),
    customRequest: handleUpload,
    showUploadList: { showRemoveIcon: false }
  }

  return <>
    <Form.Item {...defConfig('selfUpload', 'select')} initialValue={0} name="detailId">
      <Radio.Group
        options={[{ value: 1, label: ln_t('util.yes') }, { value: 0, label: ln_t('util.no') }]}
        optionType="button"
        buttonStyle="solid"
        disabled={editMode}
      />
    </Form.Item>
    <Form.Item {...defConfig('analyticsPropertyId', 'input')}>
      <Input placeholder={defPlaceholder('analyticsPropertyId', 'input')} />
    </Form.Item>
    {formVal.detailId
      ? <>
        <Form.Item {...defConfig('bucketName', 'input')}>
          <Input placeholder={defPlaceholder('bucketName', 'input')} />
        </Form.Item>
        <Form.Item
          {...defConfig('saFile', 'select')}
          valuePropName="fileList"
          getValueFromEvent={e => Array.isArray(e) ? e : e?.fileList}
          name="upload"
        >
          <Upload {...uploadProps}>
            <Button icon={<UploadOutlined />} style={{ width: '100%' }}>{ln_t('util.clickToUpload')}</Button>
          </Upload>
        </Form.Item>
      </>
      : ''}
  </>
}

export default GA4extras
